import Vue from 'vue'
import vueMoment from 'vue-moment'
import vImage from './components/common/vImage'
import axios from './assets/scripts/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/main.scss'
import './assets/scripts/utils'
// import echarts from 'echarts'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.imageResourcesUrl = process.env.VUE_APP_STATIC_RESOURCES_URL
Vue.prototype.staticResourcesUrl = process.env.VUE_APP_IMAGE_RESOURCES_URL
// Vue.prototype.$echarts = echarts
Vue.use(vueMoment)
Vue.component('VImage', vImage)

export default new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    // PrerenderSPAPlugin.renderAfterDocumentEvent
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
